// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/
// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.
// THE TEMPLATE IS AT: tasks/pkg/icon-action-template/src/index.tsx
import baseIcon from '@bubble-ui/temp-icon-base';
var ActionIconArrowRightPath = 'M4.00017483,8.986 L12.9441748,8.986 L10.3281748,5.631 L11.9061748,4.4 L15.7891748,9.382 C16.0711748,9.743 16.0701748,10.25 15.7891748,10.611 L11.9051748,15.588 L10.3291748,14.357 L12.9601748,10.986 L4.00017483,10.986 L4.00017483,8.986 Z';
var ActionIconArrowRight = baseIcon('ActionIconArrowRight', {
  getPath: function getPath() {
    return ActionIconArrowRightPath;
  }
});
export default ActionIconArrowRight;
//# sourceMappingURL=index.js.map